import React, { useEffect } from "react"
import RequestDemoModal from "../../../pages/common/RequestDemoModal"
import ReceiveUpdatesModal from "../../../pages/common/ReceiveUpdatesModal"
import { Link } from "react-router-dom"
import BlogSignupSection from "../../common/BlogSignupSection"

import chart1Correlation from 'images/blog/Blog_20261007_BondCoveredCalls/chart1_long_correlation.png'
import chart1CorrelationPhone from 'images/blog/Blog_20261007_BondCoveredCalls/chart1_long_correlation-phone.png'
import chart2StocksDown from 'images/blog/Blog_20261007_BondCoveredCalls/chart2_stocks_down.png'
import chart2StocksDownPhone from 'images/blog/Blog_20261007_BondCoveredCalls/chart2_stocks_down-phone.png'
import chart3Payoff from 'images/blog/Blog_20261007_BondCoveredCalls/chart3_payoff.png'
import chart3PayoffPhone from 'images/blog/Blog_20261007_BondCoveredCalls/chart3_payoff-phone.png'

import jonAvatar from 'images/blog/avatar-100.jpg'

// No banner image exists for this post yet; the blog index card uses the correlation chart.
const BannerImage500 = chart1Correlation

const postTitle = 'When Bonds Diversify Less: Covered Calls on IEF'
const documentTitle = postTitle + ' | Clarivor'
// Card text on the blog index (from the approved post's meta description; not shown on the post page).
const postDescription = 'Since 2022, bond gains have cushioned equity losses less reliably. Selling some of that ' +
    'upside with covered calls on a Treasury ETF may be worth considering.'
const postAuthor = 'Jon Spiegel, CFA'
const publishedOnText = 'October 7, 2026'
const topic = 'income'
export const path = 'bond-covered-calls-ief-20261007'

const PHONE_MEDIA = '(max-width: 575px)'
const tdClassName = 'text-center py-2'
const thClassName = 'text-center'
const noteStyle = { fontSize: '0.8rem' }
const captionStyle = { captionSide: 'top', fontWeight: 'bold', color: 'inherit' }

const correlationData = [
    ['1962-12-31', '−0.0060'],
    ['1963-12-31', '−0.0275'],
    ['1964-12-31', '+0.0073'],
    ['1965-12-31', '+0.1300'],
    ['1966-12-30', '+0.0438'],
    ['1967-12-29', '+0.3976'],
    ['1968-12-31', '+0.1106'],
    ['1969-12-31', '+0.3386'],
    ['1970-12-31', '+0.1733'],
    ['1971-12-31', '+0.3921'],
    ['1972-12-29', '+0.2238'],
    ['1973-12-31', '+0.0662'],
    ['1974-12-31', '+0.2918'],
    ['1975-12-31', '+0.2872'],
    ['1976-12-31', '+0.2418'],
    ['1977-12-30', '+0.2755'],
    ['1978-12-29', '+0.5358'],
    ['1979-12-31', '+0.5374'],
    ['1980-12-31', '+0.4063'],
    ['1981-12-31', '+0.4112'],
    ['1982-12-31', '+0.4522'],
    ['1983-12-30', '+0.4528'],
    ['1984-12-31', '+0.4489'],
    ['1985-12-31', '+0.3219'],
    ['1986-12-31', '+0.4159'],
    ['1987-12-31', '+0.0551'],
    ['1988-12-30', '+0.4951'],
    ['1989-12-29', '−0.0307'],
    ['1990-12-31', '+0.5807'],
    ['1991-12-31', '+0.2501'],
    ['1992-12-31', '+0.1801'],
    ['1993-12-31', '+0.3220'],
    ['1994-12-30', '+0.4869'],
    ['1995-12-29', '+0.4931'],
    ['1996-12-31', '+0.5640'],
    ['1997-12-31', '+0.0484'],
    ['1998-12-31', '−0.3461'],
    ['1999-12-31', '+0.4020'],
    ['2000-12-29', '−0.1440'],
    ['2001-12-31', '−0.2116'],
    ['2002-12-31', '−0.6646'],
    ['2003-12-31', '−0.1734'],
    ['2004-12-31', '−0.2565'],
    ['2005-12-30', '−0.0116'],
    ['2006-12-29', '+0.1127'],
    ['2007-12-31', '−0.6058'],
    ['2008-12-31', '−0.4886'],
    ['2009-12-31', '−0.4294'],
    ['2010-12-31', '−0.3566'],
    ['2011-12-30', '−0.6395'],
    ['2012-12-31', '−0.5874'],
    ['2013-12-31', '−0.0186'],
    ['2014-12-31', '−0.4886'],
    ['2015-12-31', '−0.4391'],
    ['2016-12-30', '−0.1168'],
    ['2017-12-29', '−0.4073'],
    ['2018-12-31', '−0.4012'],
    ['2019-12-31', '−0.5280'],
    ['2020-12-31', '−0.1817'],
    ['2021-12-31', '−0.3926'],
    ['2022-12-30', '+0.3356'],
    ['2023-12-29', '+0.3923'],
    ['2024-12-31', '−0.0793'],
    ['2025-12-31', '−0.0356'],
    ['2026-10-01', '+0.5675'],
]

const HeroSection = (props) => (
    <section
        className='bg-dark text-white'
        style={{
            position: 'relative',
            zIndex: 0,
            minHeight: '35vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            padding: '20px'
        }}>

        <div className='container bg-dark text-white'>
            <div className={'row justify-content-center'}>
                <h1 style={{
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}>
                    {postTitle}
                </h1>
                <div className="px-md-12 mt-6">
                    <p style={{
                        fontSize: '1em',
                        textAlign: 'center'
                    }}>
                        {postAuthor} · {publishedOnText}
                    </p>
                </div>
            </div>
        </div>

    </section>)

function ShowData(props) {
    return (
        <details className='text-left text-muted mt-2' style={noteStyle}>
            <summary>Show data</summary>
            <div className='table-responsive'>
                <table className='table table-sm mt-2 mb-0'>
                    {props.children}
                </table>
            </div>
        </details>
    )
}

function Summary(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                Summary
            </h3>
            <ul>
                <li className='my-2'>
                    In September, the estimated six-month correlation between U.S. stocks and 10-year Treasuries reached +0.60, its highest since 1997. Since 2022, bond gains have cushioned equity losses less reliably.
                </li>
                <li className='my-2'>
                    If bond rallies are less likely to offset equity losses, that upside may be worth less to a diversified portfolio, and selling some of it with covered calls on a Treasury ETF may be worth considering. On October 6, a one-month IEF call, slightly out-of-the-money, was bid at 9.1% on an annualized basis.
                </li>
                <li className='my-2'>
                    The trade-off is that the calls cap bond gains, including rallies that may again cushion equity losses, and the premium offsets only a small bond decline over the month. In return, the premium can add income and the position starts with less interest rate exposure.
                </li>
            </ul>
        </React.Fragment>
    )
}

function CorrelationChart(props) {
    return (
        <div className='card mx-auto my-6'>
            <div className='card-body p-2 bg-white text-center'>
                <h3 className='text-center mb-1'>
                    Stock–Treasury correlation since 1962
                </h3>
                <p className='text-center text-muted mb-3'>
                    Estimated correlation of daily U.S. stock market and 10-year Treasury returns over the prior six months (126 trading days)
                </p>
                <picture>
                    <source media={PHONE_MEDIA} srcSet={chart1CorrelationPhone} />
                    <img src={chart1Correlation} className='img-fluid'
                        alt='Line chart of the estimated six-month correlation between U.S. stock and 10-year Treasury returns from 1962 to 2026, mostly positive before 2000, mostly negative from 2000 through 2021, and reaching +0.60 on September 9, 2026, the highest since August 13, 1997.' />
                </picture>
                <p className='text-center mt-3' style={noteStyle}>
                    Correlations calculated daily from July 5, 1962 to October 1, 2026. Dotted line and dots: September 9, 2026 (+0.60) and August 13, 1997, the last earlier day at or above it. Clarivor estimate. Stocks: Kenneth French U.S. market returns; SPY price returns from Sep 1, 2026. Treasuries: 10-year par-bond returns estimated from FRED DGS10 yields.
                </p>
                <ShowData>
                    <thead>
                        <tr>
                            <th scope="col">Date</th>
                            <th scope="col" className={thClassName}>Six-month correlation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {correlationData.map(([date, value]) => (
                            <tr key={date}>
                                <td>{date}</td>
                                <td className={tdClassName}>{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </ShowData>
            </div>
        </div>
    )
}

function Section1(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                A Less Reliable Equity Hedge
            </h3>
            <p>
                From the 1970s through the 1990s, a positive correlation between stocks and Treasuries was the norm: the estimated six-month correlation was positive 97% of the time in the 1970s, over 99% in the 1980s and 87% in the 1990s. From 2000 through 2021, it was positive only 12% of the time; since 2022, 54%.
            </p>
            <CorrelationChart />
            <p>
                Correlations can change, and bonds may again rally when stocks fall.
            </p>
        </React.Fragment>
    )
}

function PayoffChart(props) {
    return (
        <div className='card mx-auto my-6' id='payoff'>
            <div className='card-body p-2 bg-white text-center'>
                <h3 className='text-center mb-1'>
                    A covered call trades the upside above the strike for the premium
                </h3>
                <p className='text-center text-muted mb-3'>
                    Profit or loss at expiration, as a percentage of IEF’s starting price, for IEF alone and for IEF with one call contract sold per 100 shares
                </p>
                <picture>
                    <source media={PHONE_MEDIA} srcSet={chart3PayoffPhone} />
                    <img src={chart3Payoff} className='img-fluid'
                        alt='Payoff diagram: IEF alone gains or loses one for one with its price, while IEF with a covered call is higher by the premium as long as IEF ends below the strike, then stays flat once IEF ends above it. Lower rates and higher bond prices are to the right; higher rates and lower bond prices to the left.' />
                </picture>
                <p className='text-center mt-3' style={noteStyle}>
                    Example: a one-month call struck 0.5% above IEF’s $89.13 price on October 6, 2026, sold at its estimated $0.67 midpoint (see Implementation). Ignores IEF’s distributions, transaction costs and taxes.
                </p>
            </div>
        </div>
    )
}

function Section2(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                How a Covered Call Works
            </h3>
            <p>
                When writing a covered call on IEF, an ETF that holds 7–10 year Treasuries, the investor receives the price of the call (“premium”) in exchange for capping gains at the call’s strike. In addition to the premium, the investor continues to receive IEF’s distributions.
            </p>
            <PayoffChart />
        </React.Fragment>
    )
}

function Section3(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                Pricing in the Current Environment
            </h3>
            <p>
                As of October 6, 2026, with IEF at $89.13, a November 6 call struck at $89.50 was bid at $0.69, or 0.77% of IEF’s price over 31 days: 9.1% on a simple annualized basis. The quote’s midpoint was $0.705, or 0.79%.
            </p>
            <p>
                To compare option prices over time, Clarivor estimates the midpoint price of a 30-day, near-the-money IEF call from listed option quotes on each trading day since January 3, 2005. That price was relatively low through the summer and jumped in late September, from 0.69% of IEF’s price on September 22 to 0.92% on September 24. On October 6 it was 0.91%.
            </p>
            <div className='row justify-content-center'>
                <div className='col-12 col-md-11 col-lg-10'>
                    <div className='table-responsive'>
                        <table className="table table-sm">
                            <caption style={captionStyle}>How the October 6 estimate compares</caption>
                            <thead>
                                <tr>
                                    <th scope="col">Trading days</th>
                                    <th scope="col" className={thClassName}>Days</th>
                                    <th scope="col" className={thClassName}>October 6 above</th>
                                    <th scope="col" className={thClassName}>Median</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Jan 3, 2005 to Oct 6, 2026</td>
                                    <td className={tdClassName}>5,182</td>
                                    <td className={tdClassName}>72%</td>
                                    <td className={tdClassName}>0.75%</td>
                                </tr>
                                <tr>
                                    <td>Jan 3, 2022 to Oct 6, 2026</td>
                                    <td className={tdClassName}>1,192</td>
                                    <td className={tdClassName}>51%</td>
                                    <td className={tdClassName}>0.90%</td>
                                </tr>
                                <tr>
                                    <td>Oct 6, 2025 to Oct 6, 2026</td>
                                    <td className={tdClassName}>251</td>
                                    <td className={tdClassName}>94%</td>
                                    <td className={tdClassName}>0.66%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className='text-muted' style={noteStyle}>
                        30-day, 50-delta (near-the-money) IEF call, bid-ask midpoint as a percentage of IEF’s 3:45pm reference price. Clarivor estimates from listed option quotes. Each window includes October 6.
                    </p>
                </div>
            </div>
            <p>
                That estimate was above 94% of the past year’s values, when the median was 0.66%, and close to the median since 2022 (January 3, 2022 to October 6, 2026).
            </p>
        </React.Fragment>
    )
}

function StocksDownChart(props) {
    return (
        <div className='card mx-auto my-6'>
            <div className='card-body p-2 bg-white text-center'>
                <h3 className='text-center mb-1'>
                    When stocks fell, IEF used to rally. Since 2022, it has done so less often.
                </h3>
                <p className='text-center text-muted mb-3'>
                    Share of one-month periods with SPY down 2% or more in which IEF rose
                </p>
                <picture>
                    <source media={PHONE_MEDIA} srcSet={chart2StocksDownPhone} />
                    <img src={chart2StocksDown} className='img-fluid'
                        alt='Bar chart: in one-month periods when SPY fell 2% or more, IEF rose in 26 of 36 periods from 2005 to 2021 and 5 of 11 since 2022.' />
                </picture>
                <ShowData>
                    <thead>
                        <tr>
                            <th scope="col">Period</th>
                            <th scope="col" className={thClassName}>Periods</th>
                            <th scope="col" className={thClassName}>SPY (avg)</th>
                            <th scope="col" className={thClassName}>IEF (avg)</th>
                            <th scope="col" className={thClassName}>IEF rose</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>2005–2021</td>
                            <td className={tdClassName}>36</td>
                            <td className={tdClassName}>−6.5%</td>
                            <td className={tdClassName}>+1.4%</td>
                            <td className={tdClassName}>26 of 36</td>
                        </tr>
                        <tr>
                            <td>2022–Apr 2026</td>
                            <td className={tdClassName}>11</td>
                            <td className={tdClassName}>−5.5%</td>
                            <td className={tdClassName}>−1.1%</td>
                            <td className={tdClassName}>5 of 11</td>
                        </tr>
                    </tbody>
                </ShowData>
            </div>
        </div>
    )
}

function Section4(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                The Diversification Trade-Off
            </h3>
            <p>
                For a diversified portfolio, the bond rallies that matter most are the ones that occur while stocks are falling. Those are also the gains a covered call gives up. Clarivor examined 248 consecutive one-month periods from February 1, 2005 to September 25, 2026, and focused on those in which SPY fell by 2% or more.
            </p>
            <StocksDownChart />
            <p>
                Before 2022 (March 21, 2005 to March 20, 2020), IEF rose in 26 of 36 such periods; its average return across all 36 was +1.4%. Since 2022 (January 10, 2022 to April 2, 2026), it rose in only 5 of 11, averaging −1.1% across all 11. The recent sample is small, and bonds still sometimes cushion equity losses; the calls would cap those gains above the strike. But since 2022, that cushion has been less reliable than it was from 2005 to 2021.
            </p>
        </React.Fragment>
    )
}

function Section5(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                Implementation
            </h3>
            <p>
                An investor who decides to sell calls on IEF still has two choices to make: which strike to sell, and how much of the position to cover.
            </p>
            <p>
                A call struck at or near IEF’s price brings in the most premium and the largest cut in interest rate exposure, but it caps gains almost immediately. Strikes further above the price keep more of a bond rally in exchange for less premium. Covering only part of the position keeps the full upside on the uncovered part, with proportionally less premium and a smaller reduction in exposure. The table shows these trade-offs for one-month calls.
            </p>
            <div className='row justify-content-center'>
                <div className='col-12 col-md-11 col-lg-10'>
                    {/* Caption outside the scroll box so it is not cut off on phones; smaller type so more columns fit. */}
                    <p className='mb-1' style={{ fontWeight: 'bold' }}>Estimated one-month IEF calls, October 6, 2026</p>
                    <div className='table-responsive'>
                        <table className="table table-sm" style={{ fontSize: '0.78rem' }}>
                            <thead>
                                <tr>
                                    <th scope="col">Strike above IEF’s price</th>
                                    <th scope="col" className={thClassName}>Premium (30 days)</th>
                                    <th scope="col" className={thClassName}>Annualized</th>
                                    <th scope="col" className={thClassName}>Delta</th>
                                    <th scope="col" className={thClassName}>Duration, 50% covered</th>
                                    <th scope="col" className={thClassName}>Duration, 100% covered</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>At the money</td>
                                    <td className={tdClassName}>1.00%</td>
                                    <td className={tdClassName}>12.2%</td>
                                    <td className={tdClassName}>0.53</td>
                                    <td className={tdClassName}>5.0 yrs</td>
                                    <td className={tdClassName}>3.2 yrs</td>
                                </tr>
                                <tr>
                                    <td>+0.5%</td>
                                    <td className={tdClassName}>0.75%</td>
                                    <td className={tdClassName}>9.1%</td>
                                    <td className={tdClassName}>0.45</td>
                                    <td className={tdClassName}>5.3 yrs</td>
                                    <td className={tdClassName}>3.8 yrs</td>
                                </tr>
                                <tr>
                                    <td>+1%</td>
                                    <td className={tdClassName}>0.54%</td>
                                    <td className={tdClassName}>6.6%</td>
                                    <td className={tdClassName}>0.36</td>
                                    <td className={tdClassName}>5.6 yrs</td>
                                    <td className={tdClassName}>4.4 yrs</td>
                                </tr>
                                <tr>
                                    <td>+1.5%</td>
                                    <td className={tdClassName}>0.40%</td>
                                    <td className={tdClassName}>4.9%</td>
                                    <td className={tdClassName}>0.28</td>
                                    <td className={tdClassName}>5.9 yrs</td>
                                    <td className={tdClassName}>4.9 yrs</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className='text-muted' style={noteStyle}>
                        Clarivor estimates for 30-day calls struck at IEF’s price and 0.5%, 1% and 1.5% above it, interpolated from listed option quotes. Premium is the midpoint as a percentage of IEF’s price; annualized premium is simple (×365/30). Duration is IEF’s current 6.86-year effective duration (iShares) multiplied by the share of price sensitivity remaining after the calls are sold.
                    </p>
                </div>
            </div>
            <p>
                Selling calls also lowers the position’s initial interest rate exposure. Because the call loses value when IEF falls, the combined position is less sensitive to bond prices than IEF alone. A one-month call struck 0.5% above IEF’s price had an estimated delta of about 0.45: a 1% move in IEF, about $0.89 per share, would initially change the call’s value by about $0.40. Covering an entire position with that call would reduce its duration, currently 6.86 years, to roughly 3.8 years.
            </p>
            <p>
                That reduction is not fixed. After an immediate 2% decline in IEF, with volatility and time to expiration unchanged, the fully covered position’s duration would rise to about 5.8 years. If the call expires worthless, its premium offsets 0.75 percentage points of IEF’s price decline at the midpoint, ignoring transaction costs.
            </p>
        </React.Fragment>
    )
}

function Section6(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                Other Considerations
            </h3>
            <p>
                <strong>Correlations can change.</strong> If stocks fall and Treasuries rally, the calls would limit the bond gains that offset equity losses.
            </p>
            <p>
                <strong>Assignment.</strong> If IEF finishes above the strike, the shares are called away unless the investor buys back the call. Early assignment can occur before distribution dates.
            </p>
            <p>
                <strong>TLT.</strong> Some investors hold TLT, an ETF that holds 20+ year Treasuries, as their bond allocation. Calls on TLT provide more income: a near-the-money November 6 call was quoted at about 1.6% of the ETF’s price, versus 0.79% for IEF, both at the midpoint. But TLT is riskier. Its duration of about 15 years is more than twice IEF’s, and its price has been 1.8 times as volatile from October 3, 2025 to October 6, 2026. Even after selling calls, a TLT position could carry more rate exposure than IEF alone.
            </p>
        </React.Fragment>
    )
}

function Section7(props) {
    return (
        <React.Fragment>
            <h3 className={'font-weight-bold mt-6'}>
                Less Reliable Hedges, Less Upside to Keep
            </h3>
            <p>
                How much bond upside to keep is a portfolio decision. When bond rallies are less likely to offset equity losses, selling calls on part of an IEF position may exchange some of that upside for income, recognizing that the calls cap rallies that may again help and that the premium offsets only a small bond decline over the month. <Link to={'/contact'}>Contact Clarivor</Link> to compare strikes, coverage levels and exposure after a bond sell-off for your portfolio.
            </p>
            <p>
                Related: <Link to={'/blog/selling-tlt-puts-20211104'}>Selling Puts on TLT</Link> · <Link to={'/blog/TLT_Overwriting_20210413'}>Getting Paid More to Own Treasuries</Link> · <Link to={'/blog/calendar-collar-20220922'}>Calendar Collar Overlay</Link>
            </p>
        </React.Fragment>
    )
}

function MethodologyAndSourceDisclaimer(props) {
    return (
        <div>
            <hr />
            <div className='text-muted' style={{ fontSize: '0.9rem' }}>
                <details>
                    <summary><strong>Methodology and sources</strong></summary>
                    <p className='mt-3'>
                        Option prices are observed at 3:45pm ET; estimates are interpolated from listed strikes and expirations. Premiums are bid-ask midpoints as a percentage of IEF’s price unless noted; annualized premiums are simple (premium × 365 / days to expiration). The stock–Treasury correlation uses daily U.S. stock market returns (SPY from September 2026) and returns on a hypothetical 10-year par Treasury priced from FRED yields, over rolling six-month windows. The 30-day call history covers trading days since January 3, 2005 with enough listed quotes for an estimate. The one-month periods run from one listed IEF option expiration to the next; returns are price-only and exclude distributions, transaction costs and taxes.
                    </p>
                </details>
                <p className='font-italic mt-3'>
                    Source: Clarivor LLC; Kenneth R. French Data Library; Federal Reserve Bank of St. Louis (FRED); iShares. Hypothetical examples are for illustration and may not be indicative of future results. Options involve risk and are not suitable for all investors. Nothing in this post should be construed as investment advice.
                </p>
                <p className='font-italic'>
                    <DisclosuresLink /> and <TermsOfUseLink /> apply.
                </p>
            </div>
        </div>
    )
}

function DisclosuresLink(props) {
    return (
        <a data-toggle="modal" href="#disclaimerModal"
            onClick={() => null}>Disclosures</a>
    )
}

function TermsOfUseLink(props) {
    return (
        <Link to={'/terms-of-use'} target={'_blank'}
            onClick={() => null}>Terms of Use</Link>
    )
}

function PostBody(props) {
    return (
        <React.Fragment>
            <section className="pt-0 pt-md-0">
                <ReceiveUpdatesModal />
                <RequestDemoModal />
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-12 col-lg-10 col-xl-9">
                            <Summary />
                            <Section1 />
                            <Section2 />
                            <Section3 />
                            <Section4 />
                            <Section5 />
                            <Section6 />
                            <Section7 />
                            <MethodologyAndSourceDisclaimer />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}

export default function Blog_20261007_BondCoveredCalls(props) {
    useEffect(() => {
        document.title = documentTitle
    }, [])

    return (
        <React.Fragment>
            <HeroSection />
            <PostBody />
            <BlogSignupSection fromLocation={'Blog Post Bond Covered Calls IEF'} />
        </React.Fragment>
    )
}

export function RichBondCoveredCalls20261007(props) {
    return (
        <section className="pt-2 pt-md-4">
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <div className="card card-row shadow-light-lg mb-6 lift lift-lg">
                            <div className="row no-gutters">
                                <div className="col-12">

                                    <span className="badge badge-pill badge-light badge-float badge-float-inside">
                                        <span className="h6 text-uppercase">{topic}</span>
                                    </span>
                                </div>
                                <Link className="col-12 col-md-6 order-md-2 bg-cover card-img-right"
                                    style={{ backgroundImage: "url(" + BannerImage500 + ")" }}
                                    to={props.blogPath + path}>

                                    <img src="assets/img/photos/photo-27.jpg" alt="..."
                                        className="img-fluid d-md-none invisible" />

                                    <div
                                        className="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block">
                                        <svg viewBox="0 0 112 690" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </div>

                                </Link>
                                <div className="col-12 col-md-6 order-md-1">

                                    <Link className="card-body" to={props.blogPath + path}>

                                        <h2>
                                            {postTitle}
                                        </h2>

                                        <p className="text-muted mb-0">
                                            {postDescription}
                                        </p>

                                    </Link>

                                    <a className="card-meta" href="#!">

                                        <hr className="card-meta-divider" />

                                        <div className="avatar avatar-sm mr-2">
                                            <img src={jonAvatar} alt="..."
                                                className="avatar-img rounded-circle" />
                                        </div>

                                        <h6 className="text-uppercase text-muted mr-2 mb-0">
                                            Jon Spiegel
                                        </h6>

                                        <p className="h6 text-uppercase text-muted mb-0 ml-auto">
                                            <time dateTime="2026-10-07">{publishedOnText}</time>
                                        </p>

                                    </a>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}
